import React from "react";

import PageMeta from "../general/PageMeta";
import { PageLayout } from "../general/PageSections";

//Terms & Conditions, Disclaimer and Privacy Policy - same layout, text in content.js
const Legal = ({ page }) => {
  return (
    <PageLayout title={page.TITLE}>
      <PageMeta
        title={page.META_TITLE || page.TITLE}
        description={`${page.TITLE} - Candlewoods Guesthouse, Centurion.`}
      />
      <section className={"content-box legal"}>
        <hr className={"rule"} />
        {page.SECTIONS.map((section, i) => (
          <div
            key={section.title || i}
            className={"legal-section"}
          >
            {section.title ? <h2 className={"legal-title"}>{section.title}</h2> : null}
            {section.text.map((text) => (
              <p key={text}>{text}</p>
            ))}
          </div>
        ))}
      </section>
    </PageLayout>
  );
};

export default Legal;
